/**
 * 006-9 UI contract §5.2 / FR-018: `entry` on prepare is `locator` when the
 * payment step was reached through the locator flow (§2/§3) IN THIS TAB, else
 * `open_invoice_entry`. The marker lives in module memory only — never
 * browser storage, the URL, or router history state — so a refresh or a new
 * tab is an open-invoice entry again, exactly like the server sees it.
 */
const locatorEntries = new Set<string>();

export function markLocatorEntry(invoiceId: string): void {
  locatorEntries.add(invoiceId);
}

export function isLocatorEntry(invoiceId: string): boolean {
  return locatorEntries.has(invoiceId);
}

export function clearLocatorEntry(invoiceId: string): void {
  locatorEntries.delete(invoiceId);
}

/**
 * §2 / §3.2: drop a locator or navigation reference from the address bar
 * before paint by rewriting it to the bare `path` (idempotent; never a router
 * navigation, so nothing is added to history).
 */
export function scrubAddressBar(path: string): void {
  if (window.location.pathname !== path || window.location.search !== "") {
    window.history.replaceState(null, "", path);
  }
}
